module.exports = __webpack_public_path__ + "static/img/17.5bfc179c.jpg";